<template>
  <div
    :class="['docuforms__item', { 'docuforms__item--single': isSingleLine }]"
    data-testid="docuforms__item"
    @click="navigateTo()"
  >
    <div class="docuforms__row">
      <span class="docuforms__title vc-ellipsis" data-testid="docuforms__title">{{item.title}}</span>
      <span class="docuforms__date" data-testid="docuforms__date">{{item.created_at | time_today_or_date}}</span>
    </div>
    <div class="docuforms__row">
      <span class="docuforms__type"
            data-testid="docuforms__type"
            v-if="showType"
      >
        {{type}}
      </span>
      <span :class="['docuforms__staff', { 'docuforms__staff--separate': showType }]"
            data-testid="docuforms__staff"
            v-if="item.staff_name">
        {{item.staff_name}}
      </span>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: "docuformsItem",
  props: {
    item: {
      type: Object,
      required: true
    },
    showType: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  computed: {
    isSingleLine() {
      return !this.showType && !this.item.staff_name
    },
    type() {
      return this.$t(`client.matters.matter_page.docuforms_tab.format_${this.item.type === "vcita_doc" ? 'doc' : 'form'}`)
    }
  },
  methods: {
    navigateTo() {
      this.$frontageApi.navigateTo('app.docuform', { uid: this.item.uid })
    },
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";
@import '@/assets/scss/abstract/_i18n-mixins';

.docuforms {
  font-family: var(--primary-font-family);

  &__item {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    width: 100%;
    grid-row-gap: 4px;

    &--single {
      grid-row-gap: 0;
    }
  }

  &__row {
    display: flex;
    align-items: center;
  }

  &__title {
    flex-grow: 1;
    font-size: 13px;
    font-weight: 600;
    color: $black-color-1;
    @include i-padding-mirror(0, 10px);
  }

  &__date {
    color: $grey-color-4;
    white-space: nowrap;
  }

  &__type {
    color: $grey-color-6;
  }

  &__staff {
    color: $grey-color-6;
    display: flex;
    align-items: center;

    &--separate {
      &:before {
        content: '|';
        margin: 0 10px;
        font-size: 8px;
      }
    }
  }
}
</style>
